import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

interface UseBulkDownloadGlMasterProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const bulkDownloadGlMaster = async (communityId: string) =>
  await axiosAuth.get(`${GET_GL_MASTER_DATA}/community/${communityId}/bulk/download`, {
    responseType: "blob",
  });

const useBulkDownloadGlMaster = ({
  communityId,
  queryParams,
}: UseBulkDownloadGlMasterProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bulk-download-gl-master", communityId],
    queryFn: () => bulkDownloadGlMaster(communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useBulkDownloadGlMaster;
